"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscribeButtonError = void 0;
var react_1 = __importDefault(require("react"));
var currency_1 = require("@nerdwallet/currency");
var Error_1 = __importDefault(require("@nerdwallet/react-icon/nerdwallet-ui/Error"));
var use_subscribe_button_error_1 = require("../utils/use-subscribe-button-error");
var subscribe_button_error_module_css_1 = __importDefault(require("./subscribe-button-error.module.css"));
var DASHBOARD_SETTINGS_INFO_PATH = "/home/dashboard/settings/info";
var SubscribeButtonError = function () {
    var errorType = (0, use_subscribe_button_error_1.useSubscribeButtonError)().errorType;
    if (errorType === "EMAIL_LOCAL_PART_TOO_LONG") {
        return (react_1.default.createElement("div", { className: subscribe_button_error_module_css_1.default.container },
            react_1.default.createElement(Error_1.default, { color: "darkred", size: 16, textAligned: true }),
            react_1.default.createElement(currency_1.Text, { tone: "critical", size: "small" },
                "Your account email address should be no longer than 64 characters. Please",
                " ",
                react_1.default.createElement(currency_1.Link, { href: DASHBOARD_SETTINGS_INFO_PATH, style: { textDecoration: "none" }, inline: true, bold: true }, "update the registered email address"),
                " ",
                "to continue.")));
    }
    return null;
};
exports.SubscribeButtonError = SubscribeButtonError;
exports.default = exports.SubscribeButtonError;
